import getServerSidePropsFactory from '@haaretz/s-pp-get-server-side-props';
import { usePurchasePagePersonalQuery } from '@haaretz/s-pp-queries/PurchasePage';
import usePpDataVariables from '@haaretz/s-use-pp-data-variables';
import React from 'react';

import PpOffersPageHdc from './PpOffersPageHdc.page';

import type { ppQueryVariables } from '@haaretz/s-use-pp-data-variables';
import type { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = getServerSidePropsFactory('offers');

export default function OffersPageHdc(): JSX.Element {
  const excludedVariables: (keyof Required<ppQueryVariables>)[] = React.useMemo(
    () => ['selectedOfferId'],
    []
  );

  const variables = usePpDataVariables(excludedVariables);

  const { data } = usePurchasePagePersonalQuery(variables);

  return <PpOffersPageHdc {...(data || { __typename: 'Query' })} />;
}
